import React from "react";
import useTheme from "../../../components/web/layoutscommon/DarkModeStorage";
import {Btn} from "./StoreUI";
import {TbX} from "react-icons/tb";
import "../../../css/web/StoreDesign.css";

/**
 * ════════════════════════════════════════════════════════════════════════════════
 *  상점사(쇼핑몰) 이용약관 / 개인정보처리방침 팝업
 * ════════════════════════════════════════════════════════════════════════════════
 *  - 비토리지 고객용 CommonTermsPopup 과 동일한 역할이지만 내용이 상점사 전용이다.
 *  - 상점사 화면은 한국 쇼핑몰 대상이므로 번역 없이 한국어로 고정한다.
 *  - 약관 원문은 법적 문서라 아래 상수를 그대로 유지하고 표시부만 여명 디자인으로 바꿨다.
 *
 *  @param termsOfUsePopup    이용약관 표시여부
 *  @param privacyPolicyPopup 개인정보처리방침 표시여부
 *  @param closeTermsPopup    닫기 핸들러
 */
function StoreTermsPopup({termsOfUsePopup, privacyPolicyPopup, closeTermsPopup}) {

    const [theme] = useTheme();

    const title = termsOfUsePopup ? "비토리지 OpenAPI 이용약관" : "개인정보 취급처리방침";

    return (
        <div className="st-root" data-theme={theme}
             style={{position: "fixed", inset: 0, zIndex: 9999, minHeight: 0, background: "rgba(27,23,48,.5)", backdropFilter: "blur(8px)"}}
             role="dialog" aria-modal="true" aria-label={title}>
            <div className="tw-flex tw-h-full tw-items-center tw-justify-center tw-p-4">
                <div className="st-glass st-rise tw-flex tw-w-full tw-max-w-[780px] tw-flex-col tw-overflow-hidden"
                     style={{maxHeight: "86vh"}}>

                    {/*헤더*/}
                    <header className="tw-flex tw-flex-shrink-0 tw-items-center tw-justify-between tw-gap-4 tw-border-b tw-px-6 tw-py-4"
                            style={{borderColor: "var(--st-glass-line)"}}>
                        <div className="tw-min-w-0">
                            <p className="st-eyebrow tw-mb-1">Legal</p>
                            <h2 className="st-display tw-truncate tw-text-[17px] tw-text-[color:var(--st-text)]">{title}</h2>
                        </div>
                        <button type="button" onClick={closeTermsPopup} aria-label="닫기"
                                className="st-btn st-btn-glass st-btn-sm st-btn-icon tw-flex-shrink-0 tw-text-[17px]">
                            <TbX/>
                        </button>
                    </header>

                    {/*본문*/}
                    <div className="st-scroll tw-flex-1 tw-overflow-y-auto tw-px-6 tw-py-6 tw-text-[13px] tw-leading-[1.95] tw-text-[color:var(--st-text-sub)] tw-break-keep"
                         style={{whiteSpace: "pre-line"}}>
                        {termsOfUsePopup ? TERMS_OF_USE : PRIVACY_POLICY}
                    </div>

                    {/*푸터*/}
                    <footer className="tw-flex tw-flex-shrink-0 tw-justify-end tw-border-t tw-px-6 tw-py-4"
                            style={{borderColor: "var(--st-glass-line)"}}>
                        <Btn tone="dawn" size="md" onClick={closeTermsPopup} className="tw-min-w-[120px]">확인</Btn>
                    </footer>
                </div>
            </div>
        </div>
    );
}

export default StoreTermsPopup;

/* ── 이용약관 ─────────────────────────────────────────────────────────────── */
const TERMS_OF_USE = `제1조 (목적)
이 약관은 주식회사 비토리지(이하 "회사")가 제공하는 구매대행 API 연동 서비스(이하 "API 서비스")를 이용함에 있어 회사와 이를 도입하는 국내 쇼핑몰 사업자(이하 "상점사") 간의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.

제2조 (정의)
1. "API 서비스"란 상점사의 상품페이지 또는 장바구니 페이지에 회사가 제공하는 API 버튼을 삽입하여, 상점사의 상품 정보를 회사의 시스템(비토리지 웹/앱 주문서)에 실시간으로 연동함으로써, 상점사의 최종 고객(이하 "구매자")이 회사의 구매대행 서비스를 이용해 해당 상품을 해외로 구매·배송받을 수 있도록 하는 일체의 서비스를 말합니다.
2. "API 키"란 상점사가 API 서비스를 이용하기 위해 회사로부터 발급받는 고유 인증 값을 말합니다.
3. "연동 상품 데이터"란 API 버튼 클릭 시 회사 시스템으로 전달되는 상품명, 옵션, 수량, 가격, 배송비, 상품 URL 등 일체의 정보를 말합니다.
4. "구매대행 주문"이란 구매자가 회사의 주문서를 통해 대금을 결제한 후, 회사가 상점사의 통상적인 국내 판매 채널(홈페이지 등)을 통해 해당 상품을 구매하는 절차를 말합니다.

제3조 (약관의 게시와 개정)
1. 회사는 이 약관의 내용을 상점사 대시보드 초기 화면 또는 연결 화면에 게시합니다.
2. 회사는 관련 법령을 위반하지 않는 범위에서 이 약관을 개정할 수 있으며, 개정 시 적용일자 및 개정사유를 명시하여 최소 7일 전(상점사에게 불리한 개정은 30일 전) 공지합니다.
3. 상점사가 개정약관 공지 후에도 API 서비스를 계속 이용하는 경우 개정에 동의한 것으로 봅니다.

제4조 (계약의 체결)
1. 상점사가 되고자 하는 자는 회사가 정한 가입 양식에 따라 회원정보(이메일, 상호명, 담당자명, 담당자연락처 등)를 기재하고 이 약관 및 개인정보처리방침에 동의함으로써 이용계약이 체결됩니다.
2. 회사는 다음 각 호에 해당하는 경우 승낙을 유보하거나 거절할 수 있습니다.
   a. 가입 신청 내용에 허위, 기재누락, 오기가 있는 경우
   b. 관계 법령에서 취급을 금지하거나 제한하는 품목을 주력으로 취급하는 쇼핑몰인 경우
   c. 그 밖에 회사의 운영상 현저한 지장이 있다고 판단되는 경우
3. 회사는 상점사에게 API 키를 발급하며, 상점사는 발급된 API 키를 통해서만 API 서비스에 접근할 수 있습니다.

제5조 (API 키 관리 책임)
1. 상점사는 발급받은 API 키를 선량한 관리자의 주의의무로 관리해야 하며, 제3자에게 양도, 대여, 담보 제공할 수 없습니다.
2. API 키의 관리 소홀로 인해 발생한 손해에 대해 회사는 책임을 지지 않으며, 상점사는 유출 사실을 인지한 즉시 회사에 통지하고 재발급을 요청해야 합니다.
3. 회사는 상점사의 API 서비스 제공 여부를 통제할 수 있으며, 비활성화 상태에서의 API 호출은 거부됩니다.

제6조 (서비스 내용 및 절차)
1. 상점사는 상품페이지 또는 장바구니 페이지에 회사가 제공하는 가이드라인에 따른 API 버튼을 삽입합니다.
2. 구매자가 API 버튼을 클릭하면 연동 상품 데이터가 회사 시스템으로 전달되고, 이후의 주문서 작성, 결제, 배송, 통관, 고객 응대는 전적으로 회사의 책임과 절차에 따라 진행됩니다.
3. 회사가 구매자의 주문을 확인한 후 상점사의 통상적인 국내 판매 채널을 통해 정상적으로 구매대행 주문을 진행하며, 상점사는 이를 일반 국내 소비자 주문과 동일하게 처리합니다.
4. 상점사는 회사의 구매대행 주문에 대해 정당한 사유 없이 차별적으로 취급(가격 차등, 재고 우선순위 배제 등)해서는 안 됩니다.

제7조 (수출입 및 통관 책임)
1. 본 API 서비스는 완전한 구매대행 형식의 주문 연동으로, 관련 수출신고는 상점사 명의가 아닌 회사 명의로 이루어지며, 상점사는 이에 대한 별도 조치를 취할 필요가 없습니다.
2. 해외배송 및 통관 과정에서 발생하는 관세, 통관 지연, 반송, 분실 등과 관련한 비용 및 책임은 상품 자체의 하자에 기인한 경우를 제외하고 회사가 부담합니다.
3. 다만, 상점사가 제공한 상품 정보(연동 상품 데이터)의 오류·허위 기재로 인해 발생한 통관 문제에 대해서는 상점사가 책임을 부담할 수 있습니다.

제8조 (상품 하자 및 교환·환불)
1. 상품 자체의 하자, 오배송 등 상품 자체에 기인한 문제가 발생한 경우, 상점사의 기존 국내 판매 채널에 적용되는 교환·취소·환불 규정을 동일하게 적용합니다.
2. 다만 해외배송의 특성상 처리 기간은 상호 협의에 따라 연장될 수 있습니다.
3. 회사의 국제운송 과정에서 발생한 파손, 분실 등 회사 귀책 사유로 인한 문제는 회사가 구매자에게 직접 책임집니다(비토리지 고객 이용약관 제12조 준용).

제9조 (정산 및 대금)
1. 구매자가 회사에 결제한 1차 상품대금 중 상품가액에 해당하는 부분은 회사가 상점사의 통상적인 판매 채널을 통해 정상적으로 결제·구매하는 방식으로 정산되며, 이는 상점사 입장에서 일반 소비자 주문과 동일하게 처리됩니다.
2. 회사가 API 서비스 이용에 대해 상점사에게 별도의 수수료를 부과하는 경우, 그 요율 및 정산 주기는 별도 정책 또는 개별 계약으로 정합니다.
3. 해외배송료(2차 결제)는 구매자와 회사 간의 거래로, 상점사와는 무관하며 상점사에게 정산 의무가 발생하지 않습니다.

제10조 (데이터 및 개인정보의 취급)
1. 회사는 연동 상품 데이터 및 API 서비스 이용 과정에서 취득한 정보를 본 서비스 제공 목적 범위 내에서만 이용합니다.
2. 구매자의 개인정보(수취인정보 등)는 회사와 구매자 간의 "비토리지 고객 개인정보처리방침"에 따라 처리되며, 상점사는 이에 대해 별도로 접근·수집하지 않습니다.
3. 상점사는 자신의 상품 정보(연동 상품 데이터)를 회사에 제공하는 것에 동의하며, 회사는 이를 API 서비스 제공 목적 외로 사용하지 않습니다.
4. 회사와 상점사는 관련 법령(개인정보보호법, 정보통신망법 등)을 준수하여 정보를 취급합니다.

제11조 (지식재산권)
1. 회사가 제공하는 API, 연동 가이드, 비토리지 버튼 UI 등에 대한 지식재산권은 회사에 귀속됩니다.
2. 상점사는 회사의 사전 서면 동의 없이 API, 가이드, 버튼 UI 등을 복제, 변형, 재배포, 역설계할 수 없습니다.
3. 상점사가 제공한 상품 정보 및 상표 등에 대한 권리는 상점사에 귀속되며, 회사는 API 서비스 제공 목적 범위 내에서만 이를 사용합니다.

제12조 (기밀유지)
1. 회사와 상점사는 본 계약과 관련하여 알게 된 상대방의 영업상·기술상 비밀을 계약 종료 후에도 제3자에게 누설하거나 목적 외로 사용해서는 안 됩니다.
2. 다만 법령상 공개 의무가 있는 경우는 예외로 합니다.

제13조 (금지행위)
상점사는 다음 각 호의 행위를 해서는 안 됩니다.
1. API 키를 부정하게 사용하거나 타인에게 제공하는 행위
2. 허위 또는 왜곡된 상품 정보를 연동하는 행위
3. 관계 법령상 수출입이 금지·제한된 품목을 API 서비스를 통해 유통하는 행위
4. 회사의 API 서비스를 우회하거나 비정상적인 방법으로 접근하는 행위
5. 그 밖에 회사의 정상적인 서비스 운영을 방해하는 행위

제14조 (계약 해지)
1. 상점사는 언제든지 대시보드를 통해 API 서비스 해지(회원탈퇴)를 요청할 수 있습니다.
2. 회사는 상점사가 제13조를 위반하거나 6개월 이상 API 서비스 이용 실적이 없는 경우, 사전 통지 후 상점사의 API 키를 비활성화하거나 계약을 해지할 수 있습니다.
3. 계약 해지 시에도 해지 전 이미 발생한 구매대행 주문에 대한 각 당사자의 의무는 유효하게 존속합니다.
4. 상점사가 회사에 전혀 협조적이지 않거나 연락 및 소통이 원활하지 않은 경우에도 계약을 해지할 수 있습니다.

제15조 (책임의 제한)
1. 회사는 천재지변, 국가 간 통관 정책 변경 등 회사의 귀책사유가 없는 사유로 인한 서비스 중단·지연에 대해 책임을 지지 않습니다.
2. 회사는 상점사가 제공한 연동 상품 데이터의 오류로 인해 발생한 손해에 대해 책임을 지지 않습니다.

제16조 (분쟁해결 및 준거법)
1. 본 약관과 관련한 분쟁에 대한 소송은 제소 당시 회사의 주소를 관할하는 법원을 전속관할로 합니다.
2. 본 약관에는 대한민국 법을 적용합니다.

■ 추가 안내
• 완전한 구매대행 형식의 주문연동 API 서비스인 만큼 쇼핑몰 측 명의로 수출신고는 불가하며, 쇼핑몰 측에서는 국내에 판매하는 경로와 동일한 절차입니다.
• 상품 하자/오배송 등의 상품 문제 상황 발생 시 전반적으로 쇼핑몰 측의 국내로 판매 채널과 동일한 상품의 교환/취소/환불 규정을 적용하지만 해외배송 특성상 기간은 상호간의 협의에 따라 연장이 가능합니다.`;

/* ── 개인정보 취급처리방침 ────────────────────────────────────────────────── */
const PRIVACY_POLICY = `■ 수집하는 정보 및 목적
회사는 상점사 대상 회원가입, 대시보드 제공, OpenAPI 발급 및 원활한 영업/CS 소통, API 서비스 제공을 위해 아래와 같은 상점의 개인 및 기업 정보를 수집하고 있습니다.
• 이메일, 비밀번호, 상호명, 담당자성함, 담당자연락처 (회원가입·본인확인·고객지원 목적)
• API 키 발급·이용 내역 (서비스 인증 및 부정이용 방지 등의 목적)
• 연동 상품 데이터(상품명, 옵션, 가격 등) (구매대행 주문 처리 목적, 개인정보 아님)

■ 정보의 보유 및 이용기간
• 회원 탈퇴 시 지체 없이 파기하며, 관계 법령(전자상거래법 등)에 따라 보존이 필요한 거래기록은 해당 법령이 정한 기간 동안 보관합니다.

■ 제3자 제공
• 회사는 상점사의 정보를 본인 동의 없이 제3자에게 제공하지 않습니다. 다만 법령에 따라 요구되는 경우는 예외로 합니다.
• 구매자(상점사의 최종 고객)의 개인정보는 상점사에 제공되지 않으며, 회사와 구매자 간 별도 처리방침(비토리지 고객 개인정보처리방침)에 따라 관리됩니다.

■ 안전성 확보조치
• API 키 및 담당자 개인정보는 데이터베이스에 암호화하여 저장하며, 접근 권한을 최소화하고 접근 기록을 관리합니다.

■ 상점사의 권리
• 상점사는 언제든지 대시보드를 통해 본인 정보의 열람, 정정, 삭제(회원탈퇴)를 요청할 수 있습니다.

■ 개인정보 보호책임자
성명: 임은우
이메일: hcm@btorage.com
전화번호: 010-3338-9354`;
